import React, { useEffect, useRef } from 'react';

const BGMusic = ({ src, volume = 0.5, isPlaying = true }) => {
    const audioRef = useRef(null);

    useEffect(() => {
        if (!audioRef.current) return;

        const playAudio = () => {
            audioRef.current.play()
                .then(() => {
                    window.removeEventListener('click', playAudio);
                })
                .catch((err) => {
                    console.log("Autoplay blocked. Awaiting user interaction.");
                });
        };

        if (isPlaying) {
            audioRef.current.play().catch(() => {
                window.addEventListener('click', playAudio);
            });
        } else {
            audioRef.current.pause();
            window.removeEventListener('click', playAudio);
        }
    });

    useEffect(() => {
    if (audioRef.current) {
        const validVolume = isFinite(volume) && volume !== null ? volume : 0.5;
        audioRef.current.volume = validVolume;
    }
}, [volume]);

    return (

        <audio 
            ref={audioRef} 
            src={src} 
            loop 
            preload="auto"
        />
    );
};

export default BGMusic;